<div class="top-logo justify-content-center mt-2 mb-2">
  <img class="desktop-div" src="assets/images/logo.svg" alt="" />
  <img class="mobile-div" src="assets/images/collapse.svg" alt="" />
</div>

<ul class="pt-2">
  @for (link of links; track link.key || link.label) {
    @if (link.isVisible(category)) {
      <li>
        <a
          class="d-flex align-items-center justify-content-between position-relative w-100"
          [ngClass]="{ 'collapsed is-active': isSubMenuOpen(link.key || '') }"
          [routerLink]="link.routerLink ? link.routerLink : null"
          [attr.href]="link.onClick ? '#' : null"
          (click)="toggleSubMenu(link.key || '', link); link.onClick ? $event.preventDefault() : null"
          [routerLinkActive]="link.routerLink ? 'is-active' : ''"
        >
          <div class="d-flex align-items-center gap-1">
            <i [ngClass]="link.iconClass"></i>
            <span class="fs-6">{{ link.label | translate }}</span>
          </div>
          @if (link.subLinks) {
            <i class="das" [ngClass]="isSubMenuOpen(link.key || '') ? 'das-down-arrow' : 'das-arrow-right'"></i>
          }
        </a>

        @if (link.subLinks && isSubMenuOpen(link.key || '')) {
          <ul class="sub-user-menu">
            @for (subLink of link.subLinks; track subLink.label) {
              @if (subLink.isVisible(category)) {
                <li class="w-100">
                  <a
                    class="d-flex align-items-center justify-content-start position-relative w-100 gap-2"
                    [routerLink]="subLink.routerLink"
                    routerLinkActive="is-active"
                    (click)="onSubLinkClick()"
                  >
                    <i class="das das-arrow-right fs-14"></i>
                    <span class="fs-14">{{ subLink.label | translate }}</span>
                  </a>
                </li>
              }
            }
          </ul>
        }
      </li>
    }
  }
</ul>

<div class="footer-logo position-absolute start-0 w-100 justify-content-center">
  <img src="assets/images/PH-Logo-sidebar.svg" class="PH Logo" alt="PH Logo" />
</div>
